import { zodLess, ZodLessSchema, ZodLessSchemaToZod, ZodTypeAny } from '@kaiizen/zod-less';
import { OpenApiMetadata } from './openApiTypes';
import { HttpMethodUppercase } from './types';

const FIND_EXPRESS_PARAMS_IN_PATH = /:(\w+)/g;

export type EndPoint<In extends ZodTypeAny, Out extends ZodTypeAny> = {
  method: HttpMethodUppercase;
  path: string;
  input: In;
  output: Out;
  openapi?: OpenApiMetadata;
};

export type ZodLessEndpointDefinition<In extends ZodLessSchema, Out extends ZodLessSchema> = {
  method: HttpMethodUppercase; // default to GET
  path: string;
  input: In;
  output: Out;
  openapi?: OpenApiMetadata;
};

/**
 * Create a ZodLessApi Endpoint from a ZodLessEndpointDefinition.
 * @param declaration - The ZodLessEndpointDefinition.
 * @returns The ZodLessApi Endpoint.
 */
export const endPoint = <In extends ZodLessSchema, Out extends ZodLessSchema>(
  declaration: ZodLessEndpointDefinition<In, Out>,
): EndPoint<ZodLessSchemaToZod<In>, ZodLessSchemaToZod<Out>> => {
  if (FIND_EXPRESS_PARAMS_IN_PATH.test(declaration.path)) {
    throw new Error(
      'Express-style path parameters are not supported in ZodLessEndpointDefinition. A single, optional :key param is always added by zod-less-api to the path. Invalid path: '
        + declaration.path,
    );
  }
  return {
    ...declaration,
    input: zodLess(declaration.input),
    output: zodLess(declaration.output),
  };
};
